import { Breadcrumbs as MuiBreadcrumbs, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useHistory } from 'react-router';


export const Breadcrumbs = MuiBreadcrumbs;


const useBreadcrumbLinkStyles = makeStyles<{ isLink?: boolean }>()((theme, props) => ({
  link: {
    cursor: props.isLink ? 'pointer' : undefined,
  }
}));

export const Breadcrumb: React.FC<{
  currentPage?: boolean;
  to?: string;
}> = ({ currentPage, to, ...props }) => {
  const { classes } = useBreadcrumbLinkStyles({ isLink: !!to });
  const history = useHistory();

  return (
    <Typography
      className={classes.link}
      color={currentPage ? 'textSecondary' : 'textPrimary'}
      onClick={to ? () => history.push(to) : undefined}
      {...props}
    />
  );
};

